export const PARTICIPANT_MENU_ITEMS = {
  INVITE_MORE_TESTERS: 'Invite More Testers',
  PENDING_TESTERS: 'Pending Testers',
  COMPLETED: 'Completed',
  EXPIRED: 'Expired',
  RECRUITING_LINK: 'Recruiting Link',
  STATUS: 'Status',
  INTEGRATIONS: 'Integrations',
  REDIRECT: 'Redirect',
};
